import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { SupportInfo } from '../modal';

export default function reducer(state: SupportInfo = new SupportInfo(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.SUPPORT_INFO_LIST_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.SUPPORT_INFO_LIST_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.SUPPORT_INFO_LIST_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
